import { StorageEnum } from 'utils/StorageEnum';

export class CtPrivacyRepository {
  /**
   * @param {boolean} isPublic
   */
  static setIsPublic(isPublic) {
    localStorage.setItem(StorageEnum.CT_IS_PUBLIC, isPublic.toString());
  }

  /**
   * @return {boolean}
   */
  static isPublic() {
    return localStorage.getItem(StorageEnum.CT_IS_PUBLIC) === 'true';
  }

  static isPrivate() {
    return !CtPrivacyRepository.isPublic();
  }
}
